<template>
  <div class="dropMark flex1">
    <div class="flex-column h100 flex1">
      <div>
        <div class="block">
          <div class="inblock">
            时间:
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd hh:mm:ss"
            ></el-date-picker>
          </div>
          <div class="inblock ml10">
            条码:
            <el-input v-model="really_code" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            <el-radio v-model="radio" label="1">领取</el-radio>
            <el-radio v-model="radio" label="2">未领取</el-radio>
          </div>
        </div>
        <div class="block mt10">
          <div class="inblock">
            颜色:
            <el-input v-model="color" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            品牌:
            <el-input v-model="brand" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            名称:
            <el-input v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            <el-button type="primary" @click="_query()">查询</el-button>
          </div>
        </div>
      </div>
      <div class="mt10">
        <el-card class="box-card">
          <div>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[20, 30, 40, 50]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dropWatchList.info.count"
            ></el-pagination>
          </div>
        </el-card>
      </div>
      <div class="mt10 flex1 flex-column h100">
        <el-card class="flex1 flex list">
          <div>
            <el-row>
              <el-col
                :span="8"
                v-for="(item, index) in dropWatchList.list"
                :key="index"
                :offset="index > 0 ? 2 : 0"
              >
                <el-card :body-style="{ padding: '0px' }">
                  <div class="flex shop">
                    <div class="shopImg">
                      <img class="img" :src="item.image" alt="图片地址不正确请联系开发人员" />
                    </div>
                    <div style="padding: 14px;" class="bottom clearfix flex1">
                      <div class="name">名称: {{item.name}}</div>
                      <div>颜色: {{item.color}}</div>
                      <div>品牌: {{item.brand}}</div>
                      <div>水洗码: {{item.provision_code}}</div>
                      <div>{{item.find_time}}</div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 300,
      time: [],
      color: '',
      brand: '',
      name: '',
      really_code: '',
      radio: '1',
      currentPage4: 4,
      dropWatchList: {
        list: [],
        info: {}
      },
      page: 1,
      limit: 20
    }
  },
  created() {
    this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D h:m:s')
    this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D h:m:s')
    this._query()
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.limit = val
      this._query()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val
      this._query()
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    async _query() {
      let data = {
        startTime: this.time[0],
        endTime: this.time[1],
        status: this.radio,
        really_code: this.really_code,
        brand: this.brand,
        color: this.color,
        name: this.name,
        page: this.page,
        limit: this.limit

      }
      let res = await this.$http.findLossBid(data)
      this.dropWatchList = res.data.data
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/view/dropMark.less";
</style>
<style lang="less">
.dropMark {
  .el-card__body {
    overflow-y: scroll;
    flex: 1;
  }
  .el-tabs__content {
    flex: 1;
    display: flex;
    .el-tab-pane {
      flex: 1;
      display: flex;
    }
  }
}
</style>